import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/home/Home';
import NoteForm from './components/clinicalNoteForm/NoteForm';
import Navigation from './components/navigation/Navigation';
import SignIn from './components/auth/SignIn';
import Logout from './components/auth/Logout';
import Register from "./components/auth/Register";
import TemrsOfService from "./components/legal/TermsOfService";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import Disclaimer from "./components/legal/Disclaimer";
const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // State for login status
  const [diagnosis, setDiagnosis] = useState('');
  const [subjective, setSubjective] = useState('');
  const [objective, setObjective] = useState('');
  const [noteType, setNoteType] = useState('SOAP');
  const [responseNote, setResponseNote] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedLoginStatus = sessionStorage.getItem('isLoggedIn');
    if (storedLoginStatus === 'true') {
      setIsLoggedIn(true);
    }
  }, []);

  // Function to handle login
  const handleLogin = () => {
    setIsLoggedIn(true);
    sessionStorage.setItem('isLoggedIn', 'true'); // Store login status in session storage
  };

  // Function to handle logout
  const handleLogout = () => {
    setIsLoggedIn(false);
    sessionStorage.removeItem('isLoggedIn'); // Remove login status from session storage
  };

  // Function to handle note submission
  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    const data = { diagnosis, subjective, objective, noteType };

    try {
      const response = await axios.post('/psychology-ai-notes-generator/api/generate-note.php', data);
      const generatedNote = response.data.choices[0].message.content;
      setResponseNote(generatedNote);
    } catch (error) {
      console.error("There was an error generating the note!", error);
    }

    setTimeout(() => {
      setLoading(false);
      alert("Note generated successfully!");
    }, 3000);
  };

  return (
      <Router basename="/psychology-ai-notes-generator">
        <Navigation isLoggedIn={isLoggedIn} handleLogin={handleLogin} handleLogout={handleLogout} />
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          <Route path="/sign-in" element={<SignIn setIsLoggedIn={setIsLoggedIn} />} />
          <Route path="/logout" element={<Logout onLogout={handleLogout} />} />
          <Route path="/register" element={<Register />} />
          {isLoggedIn && (
              <Route
                  path="/note-form"
                  element={<NoteForm
                      diagnosis={diagnosis}
                      setDiagnosis={setDiagnosis}
                      subjective={subjective}
                      setSubjective={setSubjective}
                      objective={objective}
                      setObjective={setObjective}
                      noteType={noteType}
                      setNoteType={setNoteType}
                      responseNote={responseNote}
                      loading={loading}
                      handleSubmit={handleSubmit}
                  />}
              />
          )}
          {/* Add more routes as needed */}
            <Route path="/terms-of-service" element={<TemrsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
      </Router>
  );
};

export default App;
